const Toggle = ({ title, setOpen, open }) => {
  return (
    <div className="">
      <label className="flex items-center gap-2">
        {title}
        <div onClick={() => setOpen(open ? 0 : 1)} className={`h-6 w-11 rounded-full p-1 transition ${open ? "bg-blue-600" : "bg-gray-300"}`}>
          <div className={`h-4 w-4 bg-white rounded-full transition ${open ? "translate-x-5" : ""}`} />
        </div>
      </label>
    </div>
  );
};
export default Toggle;
